import { apiCall, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import { parseQueryParams } from '../../utils/queryParams';
import {
  getAccessStatisticsListMock,
  getActivityListMock,
  getActivityStatisticsListMock,
  getCategoryListMock,
  getCategoryStatisticsListMock,
  getCourseStatisticsListMock,
  getTutorListMock,
  getTutorStatisticsListMock,
  getLogsListMock,
  getLastCacheInvalidateMock,
  getCacheInvalidateMock,
} from './mock';
import { trackingPath, utilsPath } from '../../utils/paths';

export default {
  getAccessStatisticsList: (filters) => {
    if (shouldUseMock()) {
      return getAccessStatisticsListMock();
    }
    return apiCall(
      `${baseUrl}${trackingPath}access/statistics/list${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  getActivityStatisticsList: (filters) => {
    if (shouldUseMock()) {
      return getActivityStatisticsListMock();
    }
    return apiCall(
      `${baseUrl}${trackingPath}activity/statistics/list${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  getActivityList: (filters) => {
    if (shouldUseMock()) {
      return getActivityListMock();
    }
    return apiCall(
      `${baseUrl}${trackingPath}activity/list${parseQueryParams(filters)}`,
      'GET'
    );
  },
  getCategoryStatisticsList: (filters) => {
    if (shouldUseMock()) {
      return getCategoryStatisticsListMock();
    }
    return apiCall(
      `${baseUrl}${trackingPath}category/statistics/list${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  getCategoryList: (filters) => {
    if (shouldUseMock()) {
      return getCategoryListMock();
    }
    return apiCall(
      `${baseUrl}${trackingPath}category/list${parseQueryParams(filters)}`,
      'GET'
    );
  },
  getTutorStatisticsList: () => {
    if (shouldUseMock()) {
      return getTutorStatisticsListMock();
    }
    return apiCall(`${baseUrl}${trackingPath}tutor/statistics/list`, 'GET');
  },
  getTutorList: (filters) => {
    if (shouldUseMock()) {
      return getTutorListMock();
    }
    return apiCall(
      `${baseUrl}${trackingPath}tutor/list${parseQueryParams(filters)}`,
      'GET'
    );
  },
  getCourseStatisticsList: (filters) => {
    if (shouldUseMock()) {
      return getCourseStatisticsListMock();
    }
    return apiCall(
      `${baseUrl}${trackingPath}course/statistics/list${parseQueryParams(
        filters
      )}`,
      'GET'
    );
  },
  getLogsList: (filters) => {
    if (shouldUseMock()) {
      return getLogsListMock();
    }
    return apiCall(
      `${baseUrl}${trackingPath}logs/list${parseQueryParams(filters)}`,
      'GET'
    );
  },
  getLastCacheInvalidate: (cache_tag) => {
    if (shouldUseMock()) {
      return getLastCacheInvalidateMock();
    }
    return apiCall(
      `${baseUrl}${utilsPath}statistics/invalidated/last?cache_tag=${cache_tag}`,
      'GET'
    );
  },
  cacheInvalidate: (body) => {
    if (shouldUseMock()) {
      return getCacheInvalidateMock();
    }
    return apiCall(
      `${baseUrl}${utilsPath}statistics/invalidate/cache`,
      'POST',
      body
    );
  },
};
